namespace RedBullMOBILE360.Utilities {
    export interface ReAuthExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class ReAuthExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'Utilities.ReAuthExcelImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReAuthExcelImportForm.init)  {
                ReAuthExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(ReAuthExcelImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
